import { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { usePortal } from '../../contexts/PortalContext';
import { ACCOUNTS_DEFAULT_SLUG, ACCOUNTS_MODULES } from '../../lib/accountsModules';
import { PortalWebPushBanner } from '../notifications/PortalWebPushBanner';
import { PortalFloatingShell } from './PortalFloatingShell';
import { PortalPresenceReporter } from './PortalPresenceReporter';
import '../../styles/dem-theme-lab.css';

export function AccountsAppShell() {
  const { kind, basePath } = usePortal();

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('has-dock');
    root.style.removeProperty('--dock-clearance');
    root.style.removeProperty('--mobile-header-clearance');
    root.style.setProperty('--dock-clearance', '0px');
    root.style.setProperty('--mobile-header-clearance', '0px');
    return () => {
      root.style.removeProperty('--dock-clearance');
      root.style.removeProperty('--mobile-header-clearance');
    };
  }, []);

  const home = basePath
    ? `${basePath}/${ACCOUNTS_DEFAULT_SLUG}`
    : `/${ACCOUNTS_DEFAULT_SLUG}`;

  const nav = useMemo(
    () =>
      ACCOUNTS_MODULES.map((mod) => {
        const to = basePath ? `${basePath}/${mod.slug}` : `/${mod.slug}`;
        return {
          to,
          label: mod.label,
          icon: mod.icon,
          end: to === home,
        };
      }),
    [basePath, home],
  );

  return (
    <div className="app-shell app-shell--dock app-shell--accounts app-shell--dem-theme-lab">
      <PortalPresenceReporter portal="accounts" />
      <div className="main">
        <PortalWebPushBanner variant="toast" />
        <div className="page">
          <PortalFloatingShell portalName="Accounts" portalKind={kind} items={nav}>
            <Outlet />
          </PortalFloatingShell>
        </div>
      </div>
    </div>
  );
}
